import type { Coords } from '../../../common/types';
import { selectChargingPoints } from './selectChargingPoints';

export const MAP_MARKER_SELECTED_EVENT = 'EVENT_MAP_MARKER_SELECTED';

export interface MarkerProps {
    active: boolean;
    iconNames: string[];
    markerColor: string;
    name?: string;
    clickable?: boolean;
    fixed?: boolean;
}

export interface Marker {
    id: string;
    position: Coords;
    markerProps: MarkerProps;
    data?: Record<string, unknown>;
}

export const mapMarkerSelectedHandler = (data: Marker) => {
    if (data.data?.stationId) {
        selectChargingPoints([data.data.stationId as string]);
    }
};
